import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type LimitedDataCardProps = {
  /** BE metric title, shown muted above the indicator. */
  title?: string;
  'data-testid'?: string;
};

/**
 * KPI-card placeholder shown when the selected date range is too short to compute
 * a metric's window. Renders the metric title plus a muted "Limited data"
 * indicator instead of a value. Shared by Retention's LTV cards and Offer
 * Impact's post-redemption cards ("use the same indicator we use for retention")
 * — the caller decides which cards are limited by comparing the selected range
 * against each metric's horizon.
 */
const LimitedDataCard = ({
  title,
  'data-testid': dataTestId,
}: LimitedDataCardProps) => {
  const { t } = useTranslation();

  return (
    <Card data-testid={dataTestId}>
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {title}
        </Typography>
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          marginTop={1}
          color="text.secondary"
          data-testid={dataTestId ? `${dataTestId}.Limited` : undefined}
        >
          <InfoOutlined fontSize="small" />
          <Typography variant="caption">
            {t('page.guestJourney.retention.limitedData')}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default LimitedDataCard;
